export enum ShiftTypes {
	'day' = 'Дневная',
	'night' = 'Ночная',
}
